import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SearchPinsAdd = ({ dispatch, updatedFiltersData }) => {
  const [addButtonDisabled, setAddButtonDisabled] = useState(true);
  const [uniqueName, setUniqueName] = useState(true);
  const [pinLabel, setPinLabel] = useState('');
  const [pinQuery, setPinQuery] = useState('');

  const handleAddPin = () => {
    const lastPosition = updatedFiltersData.length;
    const key = Math.random().toString(36).substring(2, 15); // temporary key (keys are reset when put into db)
    const data = {
      featured: false,
      key,
      label: pinLabel,
      position: lastPosition,
      query: pinQuery
    };

    dispatch({ data, type: 'add-new-pin' });
    setPinLabel('');
    setPinQuery('');
    setAddButtonDisabled(true);
  };

  const isNameUnique = (newLabel) => {
    let updatedUniqueName = true;
    updatedFiltersData.forEach((filter) => {
      if (newLabel === filter.label) {
        updatedUniqueName = false;
      }
    });
    setUniqueName(updatedUniqueName);
  };

  useEffect(() => {
    if ((pinLabel === '' || pinQuery === '') || !uniqueName) {
      setAddButtonDisabled(true);
    } else {
      setAddButtonDisabled(false);
    }
  }, [pinLabel, pinQuery, uniqueName]);

  return (
    <div className="add-pin-container">
      <div className="input-container">
        <label className="brandfolder-label name-label">
          {bfTranslate("New Pin Name")}
          <input
            className="brandfolder-input t-add-label"
            onChange={(e) => {
              setPinLabel(e.target.value);
              isNameUnique(e.target.value);
            }}
            value={pinLabel}
          />
          <h4 className={classnames("duplicate-name-copy", { "show-duplicate-copy": !uniqueName })}>
            {bfTranslate('Pin Name must be unique!')}
          </h4>
        </label>
        <label className="brandfolder-label">
          {bfTranslate("New Query")}
          <input
            className="brandfolder-input t-add-query"
            onChange={(e) => setPinQuery(e.target.value)}
            value={pinQuery}
          />
        </label>
        <button
          className="button primary sm add-pin-button"
          disabled={addButtonDisabled}
          onClick={handleAddPin}
          type="button"
        >
          <span className="bff-plus icon" />
          {bfTranslate("Add pin")}
        </button>
      </div>
    </div>
  );
};

SearchPinsAdd.propTypes = {
  dispatch: PropTypes.func.isRequired,
  updatedFiltersData: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default SearchPinsAdd;
